<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" id="expert">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input
                      v-on:keyup="search"
                      name="title"
                      class="form-control bg-light border-0 small"
                      placeholder="Search Wallet"
                      aria-label="Search"
                      aria-describedby="basic-addon2"
                      v-model="filter"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="searchFor">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="all-tabs">
                  <div
                    :class="activeTab == 'all' ? 'tab-options' : ''"
                    @click.prevent="
                      fetchData('all');
                      currentPage = 1;
                    "
                    class="mx-2 opt"
                  >
                    All
                  </div>
                  |
                  <div
                    :class="activeTab == 'active' ? ' tab-options' : ''"
                    @click.prevent="
                      fetchData('active');
                      currentPage = 1;
                    "
                    class="mx-2 opt"
                  >
                    Active
                  </div>
                  |
                  <div
                    :class="activeTab == 'inactive' ? ' tab-options' : ''"
                    @click.prevent="
                      fetchData('inactive');
                      currentPage = 1;
                    "
                    class="mx-2 opt"
                  >
                    Inactive
                  </div>
                  |
                  <div
                    class="d-flex align-items-center justify-content-end"
                    v-if="can('add-wallet')"
                  >
                    <svg
                      class="svg-inline--fa fa-table mx-2"
                      height="16px"
                      width="16px"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fa"
                      data-icon="table"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      data-fa-i2svg=""
                    >
                      <path
                        fill="currentColor"
                        d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                      ></path>
                    </svg>
                    <router-link
                      :to="{ name: 'add-wallet' }"
                      class="podcast-options"
                      >Add Points</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                striped
                bordered
                :items="tableData.data"
                :per-page="0"
                :current-page="currentPage"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                responsive="sm"
                class="table-bordered table-hover"
                :key="key"
              >
                <template v-slot:cell(show_agreement)="row">
                  <b-form-checkbox
                    switch
                    class="mb-1"
                    @change="updateAgreementStatus(row.item.id)"
                    :checked="row.item.show_agreement == 1 ? true : false"
                  >
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(total_points)="row">
                  <span>
                    {{ formatAmount(row.item.total_points) }}
                  </span>
                </template>
                <template v-slot:cell(balance)="row">
                  <span>
                    {{ formatAmount(row.item.balance) }}
                  </span>
                </template>
                <template v-slot:cell(redeem_points)="row">
                  <span>
                    {{ formatAmount(row.item.redeem_points) }}
                  </span>
                </template>
                <template v-slot:cell(username)="row">
                  <span class="text-center">
                    <router-link
                      :to="{
                        name: 'single-wallet-transaction',
                        params: { id: row.item.id },
                      }"
                    >
                      <template
                        v-if="
                          row.item.username !== null && row.item.username !== ''
                        "
                      >
                        <span class="">{{ row.item.username }}</span>
                      </template>
                      <template v-else>
                        <span class="">---</span>
                      </template>
                    </router-link>
                  </span>
                </template>
                <template
                  v-can="'update-wallet-status'"
                  v-slot:cell(is_active)="row"
                >
                  <b-form-checkbox
                    switch
                    class="mb-1"
                    @change="updateStatus(row.item.id)"
                    :checked="row.item.is_active == 1 ? true : false"
                  >
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(available_points)="row">
                  <span
                    style="cursor: pointer; color: #7182df"
                    @click="addPointModal(row.item.id)"
                    class="d-flex align-items-center"
                  >
                    {{ formatAmount(row.item.available_points) }}
                    <i style="font-size: 15px" class="mdi mdi-plus-thick"></i>
                  </span>
                </template>
              </b-table>
            </div>
            <template v-if="tableData.total_pages > 1">
              <div class="data_paginate">
                <div
                  class="dataTables_paginate paging_simple_numbers d-flex justify-content-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      first-number
                      last-number
                      :total-rows="tableData.total"
                      :total-pages="tableData.total_pages"
                      :per-page="tableData.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>
        <b-modal
          id="bvModal"
          v-model="showAddPointModal"
          title="MCI Verification"
          hide-footer
          centered
          @hidden="clearAddPointModel"
        >
          <template #modal-title
            ><i class="fa fa-coins" style="color: #7182df; font-size: 20px"></i>
            Add Redeemable Coins
          </template>
          <div class="col-12 d-flex">
            <b-container class="bv-example-row">
              <b-row>
                <b-form-group
                  id="input-group-1"
                  label-for="input-1"
                  class="col-12"
                >
                  <label>Coins <span style="color: red">*</span></label>
                  <b-form-input
                    id="input-1"
                    placeholder="Enter coins"
                    type="number"
                    v-model="availablePointForm.available_points"
                  ></b-form-input>
                </b-form-group>
              </b-row>
              <b-row class="d-flex justify-content-end">
                <section class="mt-2">
                  <b-button
                    class="btn btn-success"
                    variant="success"
                    :disabled="availablePointForm.available_points == ''"
                    @click="SumbitAvailablePoints"
                  >
                    Submit
                  </b-button>
                </section>
              </b-row>
            </b-container>
          </div>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import WalletMixin from "../../../mixins/ModuleJs/wallet";

export default {
  mixins: [MixinRequest, WalletMixin],
  data() {
    return {
      title: "Wallet",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "List",
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>
